<template lang="pug">
    .livePremiere
        img.logo(src="@/assets/img/live.png")
        .content
            h4(v-html="live_event.NAME")
            .clocks-wrapper(v-if="live_event.TIMESTAMP")
                .time-before-text {{$t('broadcast.timeBefore')}}
                clocks(:initialTimestamp="live_event.TIMESTAMP")
                //- a.app_btn(:href="live_event.CODE" target="_blank") Смотреть сейчас
                a.app_btn(:href="live_event.CODE" target="_blank") {{$t('broadcast.more')}}
            a.app_btn(v-else :href="live_event.CODE" target="_blank") {{$t('broadcast.watchNow')}}
</template>

<script>
    import Clocks from "./Clocks/";

    export default {
        name: "LivePremiere",
        computed: {
            live_event() {
                return this.$store.state.live_event;
            },
        },
        components: {
            Clocks
        },
    }
</script>

<style scoped lang="scss">

    .livePremiereBlank {
        height: 7.8rem;
        margin: 7.15rem 0 0 4rem;
    }

    .livePremiere {
        display: flex;
        align-items: flex-start;
        width: 25.2rem;
    }

    .logo {
        width: 4.7rem;
        margin-right: 1rem;
        border-radius: 50%;
        box-shadow: 0 0 0 0 rgba($red, .5);
        animation: pulse 1.5s infinite;
    }

    .content {
        padding-top: 0.6rem;

        h4 {
            margin-bottom: 0.8rem;
            font-size: to_rem(30px);
            line-height: 1.05;
        }

        .time-before-text {
            font-size: 1.23rem;
            margin-bottom: 0.9rem;
        }

        .flipClock {
            position: relative;
            z-index: 1;
        }

        .app_btn {
            margin-left: -0.2rem;
            padding-left: 1.5rem;
            padding-right: 1.5rem;
        }
    }

    @keyframes pulse {
        0% {
            transform: scale(.95);
        }
        70% {
            transform: scale(1);
            box-shadow: 0 0 0 3rem rgba($red, 0);
        }
        100% {
            transform: scale(.95);
            box-shadow: 0 0 0 0 rgba($red, 0);
        }
    }

    @include mobile_or_P {
        .livePremiereBlank {
            width: 100vw;
            height: 2rem;
            padding: 0 2.2rem 0 1.4rem;
        }
        .livePremiere {
            justify-content: space-between;
            align-items: center;
            width: 100vw;
            margin-left: 0;
            padding: 1rem 2.2rem 1rem 1.4rem;
            background: linear-gradient(to bottom, #026fd3, #004c9e);
        }
        .logo {
            width: 5.7rem;
            margin-top: -0.4rem;
            margin-bottom: -0.2rem;
            margin-right: 1.5rem;
        }
        .content {
            display: flex;
            align-items: center;
            padding-top: 0;
            flex-wrap: wrap;

            h4 {
                margin-right: 1.8rem;
                margin-bottom: 0;
                font-size: 1.42rem;
            }

            .app_btn {
                padding-left: 1.3rem;
                padding-right: 1.3rem;
                font-size: 1.15rem;
            }
        }
    }
</style>
